import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_55.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter55.json";
import Head from "next/head";
export default function Chapter_55() {
  //     const corosalref = useRef()

  //     useEffect(()=>{
  //       if(corosalref.current)
  //       {
  //           corosalref.current.scrollIntoView({
  //               behavior: "smooth",
  //               block: "nearest",
  //               inline: "start"
  //           })
  //       }
  //       console.log("CurrentImageComponent",corosalref.current);
  //   },[corosalref.current])

  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;

  return (
    <>
     <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Mahā-tattva, Shakti, and Sāṃkhyā unite matter, mind, and eternal archetypes in cosmic creation."
        ></meta>
        <meta
          property="og:title"
          content="Mahā-tattva, Prakriti, and Shakti: The Cosmic Dance of Creation"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="From the Brahma-Samhita to Sāṃkhyā philosophy, Mahā-tattva is the first manifestation of Prakriti, stirred by divine glance into the play of Sattva, Rajas, and Tamas. Identified with Shakti, this cosmic principle is both the material and efficient cause of creation, projecting eternal archetypes and forms into the holographic movie of spacetime, uniting consciousness and matter."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=55"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=55"
        ></meta>
        <meta
          name="twitter:title"
          content="Mahā-tattva, Prakriti, and Shakti: The Cosmic Dance of Creation"
        ></meta>
        <meta
          name="twitter:description"
          content="The Mahā-tattva—primal matter in Sāṃkhyā—emerges when the Supreme stirs Prakriti, birthing the gunas and cosmic elements. In Śākta vision, Shakti is both substance and force, vibrating eternal archetypes into form. This is the dance of creation: the collective unconscious flowering into matter, time, and mind, where observer and observed merge in the divine play of existence."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=55" />
      </Head>
      <Common_html BlockData={BlockData} />
    </>
  );
}
